import { render, staticRenderFns } from "./LogTable.vue?vue&type=template&id=830cbf82&scoped=true"
import script from "./LogTable.vue?vue&type=script&lang=js"
export * from "./LogTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830cbf82",
  null
  
)

export default component.exports